<template>
  <div class="quick-entry-section">
    <div class="section-header">
      <!-- 快捷入口 -->
      <h3 class="section-title">{{ $t("account.quickEntry") }}</h3>
    </div>
    <div class="entry-grid">
      <div
        v-for="item in entries"
        :key="item.label"
        class="entry-item"
        @click="handleClick(item)"
      >
        <div class="entry-icon">
          <i :class="`el-icon-${item.icon}`"></i>
        </div>
        <span class="entry-label">{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuickEntrySection",
  props: {
    entries: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClick(item) {
      this.$emit("click", item);
    },
  },
};
</script>

<style lang="less" scoped>
@brand-color: #4286f5;
@text-primary: #303133;
@text-regular: #606266;
@text-secondary: #909399;

.quick-entry-section {
  background: #fff;
  border-radius: 16px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  .section-header {
    margin-bottom: 20px;

    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: @text-primary;
      margin: 0;
    }
  }

  .entry-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;

    @media (max-width: 1024px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .entry-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 20px 12px;
    border-radius: 12px;
    background-color: #fafbfc;
    transition: all 0.2s ease;

    &:hover {
      background-color: rgba(66, 134, 245, 0.08);
      transform: translateY(-2px);

      .entry-icon {
        background-color: rgba(66, 134, 245, 0.12);

        i {
          color: @brand-color;
        }
      }

      .entry-label {
        color: @brand-color;
      }
    }

    .entry-icon {
      width: 44px;
      height: 44px;
      border-radius: 12px;
      background-color: rgba(66, 134, 245, 0.08);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;

      i {
        font-size: 22px;
        color: @text-secondary;
        transition: color 0.2s ease;
      }
    }

    .entry-label {
      font-size: 13px;
      color: @text-regular;
      font-weight: 400;
      transition: color 0.2s ease;
    }
  }
}
</style>
